import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const AppliedResearch = () => {
   <ScrollToTop />
  return (
    <>
      {/* ==================== HERO ==================== */}
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Applied Research, Evaluation & Policy Analysis</h1>
          <p className="lead">
            We design and deliver rigorous, context-responsive research and evaluations to inform policy, programming, and systems reform. Our work integrates mixed-methods, political economy analysis, quasi-experimental and experimental designs, and equity-focused approaches to generate actionable, high-impact evidence.
          </p>
        </div>
      </section>

      {/* ==================== MAIN CONTENT ==================== */}
      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Baseline, midline, endline, and impact evaluations</strong>
              <p>Comprehensive assessments across the project lifecycle to rigorously measure change, effectiveness, and long-term impact using state-of-the-art methods.</p>
            </li>
            <li>
              <strong>Political economy and institutional analysis</strong>
              <p>In-depth examination of power dynamics, incentives, institutions, and contextual factors that shape development outcomes and policy implementation.</p>
            </li>
            <li>
              <strong>Gender, youth, and social inclusion studies</strong>
              <p>Equity-centered research that uncovers barriers, opportunities, and intersectional dynamics for marginalized and vulnerable populations.</p>
            </li>
            <li>
              <strong>Policy research and programme learning reviews</strong>
              <p>Evidence-based analysis and systematic reviews to refine policies, strengthen programme design, and capture institutional learning.</p>
            </li>
            <li>
              <strong>Evidence synthesis and rapid assessments</strong>
              <p>Timely, rigorous synthesis of existing data and literature to support urgent decision-making and strategic planning.</p>
            </li>
          </ul>

          {/* ==================== CTA ==================== */}
          <div className="cta-section">
            <h3>Ready to Generate Actionable Evidence?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Start Your Research Project <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== FOOTER ==================== */}
      <footer className="footer">
        <div className="footer-grid">
          <div>
            <div className="footer-logo">DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Applied Research</a></li>
              <li><a href="/services">MERL Frameworks</a></li>
              <li><a href="/services">Capacity Building</a></li>
            </ul>
          </div>
          <div>
            <h4>Thematic Areas</h4>
            <ul>
              <li><a href="/sectors">Education & Health</a></li>
              <li><a href="/sectors">Governance & Climate</a></li>
              <li><a href="/sectors">Economic Inclusion</a></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/case-studies">Projects</a></li>
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul>
              <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>
    </>
  );
};

export default AppliedResearch;
// import { ArrowLeft, ArrowRight } from 'lucide-react';
// import './ServiceDetail.css'; // or import from Services.css

// const AppliedResearch = () => {
//   return (
//     <>
//       {/* ==================== HERO ==================== */}
//       <section className="service-hero">
//         <div className="container">
//           <a href="/services" className="back-link">
//             <ArrowLeft size={24} /> Back to All Services
//           </a>
//           <h1>Applied Research, Evaluation & Policy Analysis</h1>
//           <p className="lead">
//             We design and deliver rigorous, context-responsive research and evaluations to inform policy, programming, and systems reform. Our work integrates mixed-methods, political economy analysis, quasi-experimental and experimental designs, and equity-focused approaches to generate actionable, high-impact evidence.
//           </p>
//         </div>
//       </section>

//       {/* ==================== MAIN CONTENT ==================== */}
//       <section className="section service-detail">
//         <div className="container">
//           <h2>Our Key Services</h2>
//           <ul className="service-list">
//             <li>
//               <strong>Baseline, midline, endline, and impact evaluations</strong>
//               Comprehensive assessments across the project lifecycle to rigorously measure change, effectiveness, and long-term impact using state-of-the-art methods.
//             </li>
//             <li>
//               <strong>Political economy and institutional analysis</strong>
//               In-depth examination of power dynamics, incentives, institutions, and contextual factors that shape development outcomes and policy implementation.
//             </li>
//             <li>
//               <strong>Gender, youth, and social inclusion studies</strong>
//               Equity-centered research that uncovers barriers, opportunities, and intersectional dynamics for marginalized and vulnerable populations.
//             </li>
//             <li>
//               <strong>Policy research and programme learning reviews</strong>
//               Evidence-based analysis and systematic reviews to refine policies, strengthen programme design, and capture institutional learning.
//             </li>
//             <li>
//               <strong>Evidence synthesis and rapid assessments</strong>
//               Timely, rigorous synthesis of existing data and literature to support urgent decision-making and strategic planning.
//             </li>
//           </ul>

//           {/* ==================== CTA ==================== */}
//           <div className="cta-section">
//             <h3>Ready to Generate Actionable Evidence?</h3>
//             <div className="btn-group">
//               <a href="/contact" className="btn btn-primary" style={{ background: 'white', color: 'var(--brand-primary)' }}>
//                 Start Your Project <ArrowRight size={24} />
//               </a>
//               <a href="/services" className="btn btn-secondary">
//                 View All Services <ArrowRight size={24} />
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ==================== FOOTER ==================== */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </>
//   );
// };

// export default AppliedResearch;

// import { ArrowLeft, ArrowRight } from 'lucide-react';
// import './ServiceDetail.css'; // You can create this or reuse Services.css

// const AppliedResearch = () => {
//   return (
//     <>
//       <section className="hero hero-services">
//         <div className="container">
//           <a href="/services" className="back-link">
//             <ArrowLeft size={20} /> Back to Services
//           </a>
//           <h1>Applied Research, Evaluation & Policy Analysis</h1>
//           <p className="lead">
//             We design and deliver rigorous, context-responsive research and evaluations to inform policy, programming, and systems reform. Our work integrates mixed-methods, political economy analysis, quasi-experimental and experimental designs, and equity-focused approaches to generate actionable evidence.
//           </p>
//         </div>
//       </section>

//       <section className="section service-detail">
//         <div className="container">
//           <h2>Key Services Include</h2>
//           <ul className="service-list">
//             <li><strong>Baseline, midline, endline, and impact evaluations</strong> – Comprehensive assessments across the project lifecycle to measure change and effectiveness.</li>
//             <li><strong>Political economy and institutional analysis</strong> – Deep understanding of power dynamics, incentives, and institutional contexts shaping development outcomes.</li>
//             <li><strong>Gender, youth, and social inclusion studies</strong> – Equity-focused research that identifies barriers and opportunities for marginalized groups.</li>
//             <li><strong>Policy research and programme learning reviews</strong> – Evidence-based insights to refine policies and improve programme design.</li>
//             <li><strong>Evidence synthesis and rapid assessments</strong> – Quick yet rigorous reviews of existing literature and data to inform urgent decision-making.</li>
//           </ul>

//           <div className="cta-wrapper">
//             <a href="/contact" className="btn btn-primary">
//               Start Your Research Project <ArrowRight size={20} />
//             </a>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default AppliedResearch;